/**
 * 시스템 뒤로 가기로 열린 겹(바텀 시트·드로어)을 닫는다 — 2026-10-02 사용자 신고: 폰에서 「전체」(프로필) 시트를
 * 연 채 뒤로 가기를 누르면 시트가 닫히지 않고 화면이 바뀌었다.
 *
 * CloseWatcher(Chrome 120+)가 안드로이드의 뒤로 버튼·제스처를 "닫기 요청" 으로 받는다. 기록 칸을 쓰지 않으므로
 * 라우터(calendar-spa.js)의 popstate 와 엮이지 않고, 시트 안의 링크로 떠난 뒤에 남는 빈 칸(뒤로 두 번)도 없다.
 * 없는 브라우저(Safari·Firefox)에서는 아무것도 하지 않는다 — 예전처럼 뒤로 가기가 화면을 바꾼다.
 *
 * Esc 도 닫기 요청이다(keydown 이 취소되지 않았으면 그 바로 뒤에). Esc 는 각 겹이 이미 스스로 처리하므로(팝오버
 * 등록부·mobile-shell) 그때의 close 는 무시한다 — 무시하지 않으면 Esc 한 번이 겹 둘을 닫는다. Chromium 은 그 닫기
 * 요청을 keydown 과 같은 태스크에서 보낸다(keydown → 마이크로태스크 → close → setTimeout 0 순서를 확인했다) — 그래서
 * 표시는 다음 태스크에 지운다. 시간 창(200ms)으로 재면 Esc 직후의 진짜 뒤로 가기까지 삼켰다.
 *
 * 사용법: const guard = closeOnBack(onBack, isOpen) — 겹을 열 때. 다른 길로 닫히면 guard.release().
 *   onBack: 뒤로 가기가 눌렸다. 겹을 닫으면(그 닫기가 release 를 부른다) 끝이고, 닫지 않았으면(안의 팝오버만
 *           닫았다) isOpen() 이 참인 동안 다음 뒤로 가기를 다시 지킨다.
 */
let escPending = false; // 지금 태스크가 Esc keydown 이다 — 뒤따르는 close 는 그 Esc 의 것이다
let wired = false;

function wire() {
    if (wired) return;
    wired = true;
    window.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || escPending) return;
        escPending = true;
        setTimeout(() => { escPending = false; }, 0);
    }, true);
}

export function closeOnBack(onBack, isOpen = () => false) {
    const Watcher = typeof window !== 'undefined' ? window.CloseWatcher : undefined;
    if (typeof Watcher !== 'function') return { release() {} };
    wire();
    let watcher = null;
    let released = false;
    const arm = () => {
        let mine;
        try { mine = new Watcher(); } catch (_) { return; }
        watcher = mine;
        mine.onclose = () => {
            if (watcher === mine) watcher = null;
            if (released) return;
            if (!escPending) onBack();
            setTimeout(() => { if (!released && !watcher && isOpen()) arm(); }, 0);
        };
    };
    arm();
    return {
        release() {
            if (released) return;
            released = true;
            const w = watcher;
            watcher = null;
            if (w) { try { w.destroy(); } catch (_) { /* 이미 닫혔다 */ } }
        },
    };
}
